import { createContext } from "react";

const StyleContext = createContext<{
	theme: "Light" | "Dark";
}>({
	theme: "Dark",
});
export default StyleContext;
